export const mockInventoryData = [
  {
    id: 'inv-001',
    name: 'Sterile Gloves',
    description: 'Latex-free disposable gloves',
    category: 'Consumables',
    quantityOnHand: 500,
    minStockLevel: 100,
    maxStockLevel: 600,
    reorderQuantity: 200,
    unitCost: 2.5,
    supplier: {
      id: 'sup-001',
      name: 'MedSupplies Inc.',
      leadTimeDays: 7,
      contact: 'info@medsupplies.com'
    },
    expiryDate: '2025-12-31',
    lotNumber: 'LOT123456',
    costCentre: 'Emergency Department',
    department: 'ER',
    storageLocation: 'Shelf A3',
    nappiCode: '123456789',
    imageUrl: 'https://example.com/images/gloves.jpg'
  },
  {
    id: 'inv-002',
    name: 'Blood Pressure Monitor',
    description: 'Digital automated BP monitor',
    category: 'Equipment',
    quantityOnHand: 15,
    minStockLevel: 5,
    maxStockLevel: 20,
    reorderQuantity: 5,
    unitCost: 150.0,
    supplier: {
      id: 'sup-002',
      name: 'Medical Equipment Ltd.',
      leadTimeDays: 14,
      contact: 'orders@medequip.com'
    },
    expiryDate: null,
    lotNumber: 'EQ789012',
    costCentre: 'Cardiology',
    department: 'CARD',
    storageLocation: 'Storage Room B',
    nappiCode: '234567890',
    imageUrl: 'https://example.com/images/bp_monitor.jpg'
  },
  {
    id: 'inv-003',
    name: 'Paracetamol 500mg',
    description: 'Pain relief tablets, 100 tablets per bottle',
    category: 'Medication',
    quantityOnHand: 120,
    minStockLevel: 30,
    maxStockLevel: 150,
    reorderQuantity: 50,
    unitCost: 8.75,
    supplier: {
      id: 'sup-003',
      name: 'PharmaDist',
      leadTimeDays: 3,
      contact: 'orders@pharmadist.com'
    },
    expiryDate: '2024-10-15',
    lotNumber: 'MED456789',
    costCentre: 'Pharmacy',
    department: 'PHARM',
    storageLocation: 'Medicine Cabinet P1',
    nappiCode: '345678901',
    imageUrl: 'https://example.com/images/paracetamol.jpg'
  },
  {
    id: 'inv-004',
    name: 'Surgical Masks',
    description: '3-ply disposable surgical masks, box of 50',
    category: 'PPE',
    quantityOnHand: 75,
    minStockLevel: 20,
    maxStockLevel: 100,
    reorderQuantity: 30,
    unitCost: 15.99,
    supplier: {
      id: 'sup-001',
      name: 'MedSupplies Inc.',
      leadTimeDays: 7,
      contact: 'info@medsupplies.com'
    },
    expiryDate: '2026-05-20',
    lotNumber: 'PPE123789',
    costCentre: 'General Supplies',
    department: 'ALL',
    storageLocation: 'PPE Storage Room',
    nappiCode: '456789012',
    imageUrl: 'https://example.com/images/masks.jpg'
  },
  {
    id: 'inv-005',
    name: 'Insulin Syringes',
    description: '1ml insulin syringes with needles, box of 100',
    category: 'Consumables',
    quantityOnHand: 45,
    minStockLevel: 15,
    maxStockLevel: 60,
    reorderQuantity: 20,
    unitCost: 25.5,
    supplier: {
      id: 'sup-003',
      name: 'PharmaDist',
      leadTimeDays: 5,
      contact: 'orders@pharmadist.com'
    },
    expiryDate: '2025-08-10',
    lotNumber: 'SYR567890',
    costCentre: 'Endocrinology',
    department: 'ENDO',
    storageLocation: 'Supply Room E2',
    nappiCode: '567890123',
    imageUrl: 'https://example.com/images/insulin_syringes.jpg'
  },
  {
    id: 'inv-006',
    name: 'ECG Machine',
    description: '12-lead electrocardiogram device',
    category: 'Equipment',
    quantityOnHand: 3,
    minStockLevel: 1,
    maxStockLevel: 5,
    reorderQuantity: 1,
    unitCost: 2500.0,
    supplier: {
      id: 'sup-002',
      name: 'Medical Equipment Ltd.',
      leadTimeDays: 21,
      contact: 'orders@medequip.com'
    },
    expiryDate: null,
    lotNumber: 'EQ456123',
    costCentre: 'Cardiology',
    department: 'CARD',
    storageLocation: 'Equipment Room A',
    nappiCode: '678901234',
    imageUrl: 'https://example.com/images/ecg_machine.jpg'
  },
  {
    id: 'inv-007',
    name: 'Antibiotic Ointment',
    description: 'Topical antibiotic ointment, 30g tube',
    category: 'Medication',
    quantityOnHand: 25,
    minStockLevel: 10,
    maxStockLevel: 40,
    reorderQuantity: 15,
    unitCost: 12.25,
    supplier: {
      id: 'sup-003',
      name: 'PharmaDist',
      leadTimeDays: 3,
      contact: 'orders@pharmadist.com'
    },
    expiryDate: '2024-12-05',
    lotNumber: 'MED789012',
    costCentre: 'Pharmacy',
    department: 'PHARM',
    storageLocation: 'Medicine Cabinet P3',
    nappiCode: '789012345',
    imageUrl: 'https://example.com/images/antibiotic_ointment.jpg'
  }
]

export const mockSuppliers = [
  {
    id: 'sup-001',
    name: 'MedSupplies Inc.',
    contactPerson: 'John Smith',
    email: 'info@medsupplies.com',
    phone: '+27 11 123 4567',
    address: '123 Medical Park, Johannesburg, 2000',
    leadTimeDays: 7,
    paymentTerms: 'Net 30',
    active: true
  },
  {
    id: 'sup-002',
    name: 'Medical Equipment Ltd.',
    contactPerson: 'Sarah Johnson',
    email: 'orders@medequip.com',
    phone: '+27 21 987 6543',
    address: '45 Health Avenue, Cape Town, 8001',
    leadTimeDays: 14,
    paymentTerms: 'Net 45',
    active: true
  },
  {
    id: 'sup-003',
    name: 'PharmaDist',
    contactPerson: 'David Nkosi',
    email: 'orders@pharmadist.com',
    phone: '+27 31 456 7890',
    address: '78 Pharma Road, Durban, 4001',
    leadTimeDays: 3,
    paymentTerms: 'Net 15',
    active: true
  },
  {
    id: 'sup-004',
    name: 'Lab Supplies SA',
    contactPerson: 'Jessica Meyer',
    email: 'sales@labsupplies.co.za',
    phone: '+27 12 345 6789',
    address: '224 Science Park, Pretoria, 0002',
    leadTimeDays: 10,
    paymentTerms: 'Net 30',
    active: true
  },
  {
    id: 'sup-005',
    name: 'Medical Technologies',
    contactPerson: 'Michael van der Merwe',
    email: 'info@medtech.co.za',
    phone: '+27 41 567 8901',
    address: '33 Tech Avenue, Port Elizabeth, 6001',
    leadTimeDays: 12,
    paymentTerms: 'Net 60',
    active: false
  }
]

export const mockCategories = [
  { id: 'cat-001', name: 'Consumables' },
  { id: 'cat-002', name: 'Equipment' },
  { id: 'cat-003', name: 'Medication' },
  { id: 'cat-004', name: 'PPE' },
  { id: 'cat-005', name: 'Laboratory' },
  { id: 'cat-006', name: 'Surgical' },
  { id: 'cat-007', name: 'Dental' },
  { id: 'cat-008', name: 'Office Supplies' }
]

export const mockDepartments = [
  { id: 'dept-001', name: 'Emergency Department', code: 'ER' },
  { id: 'dept-002', name: 'Cardiology', code: 'CARD' },
  { id: 'dept-003', name: 'Pharmacy', code: 'PHARM' },
  { id: 'dept-004', name: 'Laboratory', code: 'LAB' },
  { id: 'dept-005', name: 'Endocrinology', code: 'ENDO' },
  { id: 'dept-006', name: 'General Practice', code: 'GP' },
  { id: 'dept-007', name: 'Administration', code: 'ADMIN' },
  { id: 'dept-008', name: 'All Departments', code: 'ALL' }
]
